<div class="onboarding-banner-inner">
     <img class="banner-image" src="../../../../assets/images/onboarding/onboarding-banner.png" alt="">
</div>